import styled from "styled-components";


export const Label = styled.label`
color: var(--Dark-Blue-100, #002E5C);
font-feature-settings: 'clig' off, 'liga' off;
font-family: var(--MembersLabelFont-family);
font-size: 14px;
font-style: normal;
font-weight: 500;
margin-top:-4px;

`
export const CheckBox = styled.div`
display:flex;
justify-content: left;
align-items: center;
width: 14rem;
margin-top: 32px;

`
// Closed-state look of the account filter dropdowns, matched to the
// react-select dropdowns in the Finance filter.
export const FilterSelectWrapper = styled.div`
  .main__multi-select > label {
    margin-bottom: 4px;
    span:first-child {
      color: #3f4255;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .main__multi-select .MuiAutocomplete-root {
    background: #ffffff !important;
    border: 1px solid #ffffff !important;
    border-radius: 4px !important;
    cursor: pointer;
  }

  .main__multi-select .MuiAutocomplete-inputRoot {
    flex-wrap: nowrap;
    padding-right: 0 !important;
  }

  .main__multi-select .MuiAutocomplete-input {
    font-size: 14px;
    &::placeholder {
      color: hsl(0, 0%, 50%) !important;
      opacity: 1;
      font-size: 14px;
    }
  }

  .main__multi-select .MuiAutocomplete-inputRoot > span:last-of-type {
    display: flex;
    align-items: center;
    align-self: stretch;
    margin: 8px 0;
    padding: 0 8px;
    border-left: 1px solid hsl(0, 0%, 80%);

    svg {
      width: 13px;
      height: 13px;
    }
    svg path {
      fill: #b5b5c3;
    }
  }
`
export const CloseButton = styled.button`
    z-index: 9999;
`
export const CloseButtonWrapper = styled.div`
width: 100%;
display: flex;
justify-content: right;
z-index: 0;
`


export const AgeField = styled.div`
    input {
        width: 100% !important;
    }
`